import softwareAllocationType from './softwareAllocationType'
import serverAllocationType from './serverAllocationType'

const sharedSoftware = {
  softwareAllocationType,
  serverAllocationType,
}

export default sharedSoftware
